import TomSelect from 'tom-select';

export default function initializeJobOffersList() {
    document.querySelectorAll('.block-job-offers-list').forEach((block) => {
        const filterForm = block.querySelector('.block-job-offers-list__filter-form[data-ajax-form]');
        const listContainer = block.querySelector('.block-job-offers-list__list');

        if (!filterForm || !listContainer) {
            return;
        }

        const blockId = listContainer.getAttribute('data-block-id');
        let locationTomSelect = null;
        let typingTimeout = null;
        let isLoading = false;
        const typingDelay = 400;

        const locationSelect = filterForm.querySelector('select[name="filter_location[]"]');
        if (locationSelect && !locationSelect.tomselect) {
            const locationPlaceholder = locationSelect.getAttribute('data-placeholder') || 'Wybierz lokalizacje';
            locationTomSelect = new TomSelect(locationSelect, {
                plugins: ['remove_button'],
                placeholder: locationPlaceholder,
                maxItems: null,
                closeAfterSelect: false,
                allowEmptyOption: true,
                create: false,
                sortField: {
                    field: 'text',
                    direction: 'asc'
                },
                onChange: () => {
                    loadJobOffers();
                }
            });
        }

        filterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            loadJobOffers();
        });

        const titleInput = filterForm.querySelector('input[name="search_title"]');
        const keywordsInput = filterForm.querySelector('input[name="search_keywords"]');

        [titleInput, keywordsInput].forEach((input) => {
            if (!input) {
                return;
            }

            input.addEventListener('input', () => {
                const rawValue = input.value || '';
                const trimmedValue = rawValue.trim();

                if (trimmedValue.length > 0 && trimmedValue.length < 3) {
                    if (typingTimeout) {
                        clearTimeout(typingTimeout);
                    }
                    return;
                }

                if (typingTimeout) {
                    clearTimeout(typingTimeout);
                }

                typingTimeout = setTimeout(() => {
                    loadJobOffers();
                }, typingDelay);
            });
        });

        loadJobOffers();

        function loadJobOffers() {
            if (typeof jobOffersAjax === 'undefined' || isLoading) {
                if (typeof jobOffersAjax === 'undefined') {
                    console.error('jobOffersAjax is not defined');
                }
                return;
            }

            isLoading = true;
            listContainer.style.opacity = '0.5';
            listContainer.style.pointerEvents = 'none';

            const formDataInput = new FormData(filterForm);
            const params = new URLSearchParams();

            params.append('block_id', blockId);
            params.append('lang', jobOffersAjax.lang || 'pl');
            params.append('search_title', formDataInput.get('search_title') || '');
            params.append('search_keywords', formDataInput.get('search_keywords') || '');

            if (locationTomSelect) {
                const locations = locationTomSelect.getValue();
                const locationsArray = Array.isArray(locations) ? locations : (locations ? [locations] : []);

                locationsArray.forEach((loc) => {
                    params.append('filter_location[]', loc);
                });
            }

            const blockSelectedCategories = formDataInput.getAll('block_selected_categories[]');
            blockSelectedCategories.forEach((selectedCategory) => {
                params.append('block_selected_categories[]', selectedCategory);
            });

            fetch(`${jobOffersAjax.restUrl}/list?${params.toString()}`, {
                method: 'GET',
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result && result.html !== undefined) {
                        listContainer.innerHTML = result.html;
                    } else {
                        console.error('Error loading job offers:', result);
                    }
                })
                .catch((error) => {
                    console.error('AJAX error:', error);
                })
                .finally(() => {
                    isLoading = false;
                    listContainer.style.opacity = '1';
                    listContainer.style.pointerEvents = 'auto';
                });
        }
    });
}
